// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"542":"b521dd85","585":"de8d0c45","609":"584f1be0","867":"7bc5936f"}[chunkId] + ".chunk.js";
};